document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 767) return;

  document.querySelectorAll('.product-card__media--swipeable').forEach(card => {
    const track = card.querySelector('.product-card__carousel-track');
    if (!track) return;

    const slides = track.querySelectorAll('.product-card__carousel-slide');
    if (slides.length <= 1) return;

    const bar = document.createElement('div');
    bar.classList.add('product-card__progress-bar');
    const fill = document.createElement('div');
    fill.classList.add('product-card__progress-fill');
    bar.appendChild(fill);
    card.appendChild(bar);

    const totalSlides = slides.length;

    function updateProgress() {
      const index = Math.round(track.scrollLeft / track.offsetWidth);
      // margin-left gaat van 0% tot 70% (100% - 30% breedte fill)
      const marginLeft = (index / (totalSlides - 1)) * 70;
      fill.style.marginLeft = marginLeft + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
  });
});